import { ApiCaller } from "@config"
import { put } from "redux-saga/effects"
import { Utils } from "@config"
import { ReportAction } from "../actions";

export default class ReportMiddleware {
    static *GenerateReport(params) {
        const { payload } = params;

        try {
            let res = yield ApiCaller.Get(`/incidents/report${payload}`);
            if (res.status == 200) {
                yield put(ReportAction.GenerateReportSuccess(res?.data));
            }
        }
        catch (err) {
            yield put(ReportAction.GenerateReportFailure());
            Utils.showMessage('error', err?.response?.data?.message)
        }
    }
}